import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRight, Zap, Lock } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="precio" ref={ref} className="w-full bg-[var(--midnight)] py-32 md:py-40" data-id="element-114">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto px-6 text-center" data-id="element-115">
        <div className="space-y-12" data-id="element-116">
          <h2 className="font-display text-4xl md:text-6xl text-[var(--warm-gold)] italic" data-id="element-117">
            El Momento Es Ahora
          </h2>

          <div className="space-y-6 text-xl md:text-2xl text-[var(--cream)] leading-relaxed" data-id="element-118">
            <p data-id="element-119">No existe el momento perfecto para sanar.</p>

            <p className="font-semibold text-[var(--sunset-coral)]" data-id="element-120">
              Existe solo este momento. Esta página. Esta decisión.
            </p>

            <p data-id="element-121">
              Cada día que esperas es un día más cargando lo que no tienes que
              seguir cargando.
            </p>

            <p className="text-2xl md:text-3xl font-sans font-light pt-6 tracking-tight" data-id="element-122">
              La persona que quieres ser — más libre, más en paz, más viva —
              existe. Está esperando del otro lado de este proceso.
            </p>

            <p className="text-[var(--warm-gold)] text-2xl md:text-3xl font-semibold pt-4" data-id="element-123">
              El vuelo empieza con un solo paso.
            </p>

            <p className="font-display text-3xl md:text-4xl italic" data-id="element-124">
              ¿Lo vas a dar hoy?
            </p>
          </div>

          <div className="flex flex-col items-center gap-6 pt-4" data-id="element-125">
            {/* Price */}
            <div className="flex flex-col items-center gap-3" data-id="element-126">
              <div className="flex items-center gap-3" data-id="element-127">
                <span className="text-2xl md:text-3xl text-white/60 line-through font-medium" data-id="element-128">
                  $19.99
                </span>
                <span className="bg-[var(--sunset-coral)] text-white text-xs md:text-sm font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-129">
                  65% OFF
                </span>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-130">
                <span className="font-display text-6xl md:text-7xl font-bold text-[var(--warm-gold)]" data-id="element-131">
                  $6.97
                </span>
                <span className="text-lg text-white font-medium" data-id="element-132">USD</span>
              </div>
              <p className="text-sm text-white/70 italic" data-id="element-133">
                Oferta de lanzamiento — por tiempo limitado
              </p>
            </div>

            <motion.a href="https://vivemejordigital.com/cart/43814035390530:1" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="group bg-[var(--warm-gold)] text-[var(--midnight)] px-12 py-6 rounded-full font-bold text-xl md:text-2xl flex items-center gap-3 mx-auto transition-all shadow-2xl hover:shadow-[0_0_40px_rgba(201,169,97,0.5)]" data-id="element-134">
              Quiero Empezar Mi Vuelo
              <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform" data-id="element-135" />
            </motion.a>

            {/* Trust badges */}
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-white text-sm md:text-base pt-2" data-id="element-136">
              <div className="flex items-center gap-2" data-id="element-137">
                <Zap className="w-4 h-4 text-[var(--warm-gold)]" data-id="element-138" />
                <span data-id="element-139">Acceso inmediato</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-[var(--cream)]/30" data-id="element-140" />
              <div className="flex items-center gap-2" data-id="element-141">
                <Lock className="w-4 h-4 text-[var(--warm-gold)]" data-id="element-142" />
                <span data-id="element-143">Pago único y seguro</span>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}